import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
  ResponseModels_Customers_Address_AddressModel,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type GetAddressPrivate = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  postalCode: string;
  houseNumber: string;
  customerId: string;
  houseNumberSuffix?: string;
  addServiceLocationId?: boolean;
};
/**
 * Return a complete address, or an address with possible house number suffixes
 *
 * @returns ResponseModels_Customers_Address_AddressModel Success
 */
export function getAddressPrivate(
  {
    businessUnit,
    label,
    postalCode,
    houseNumber,
    customerId,
    houseNumberSuffix,
    addServiceLocationId,
  }: GetAddressPrivate,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Customers_Address_AddressModel> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/${businessUnit}/${label}/customers/${customerId}/address`,
      query: { postalCode, houseNumber, houseNumberSuffix, addServiceLocationId },
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}
